import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, List, ListItem, IconButton, Typography, Divider, CircularProgress, Tooltip, Button } from "@mui/material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { budgetActions } from "../../actions/budget.action";

import { useNavigate } from "react-router-dom";
import { currencyFormat } from "../../helpers/common";

//Components
// import Header from "../../Components/Header";
// import ArchiveBudget from "../../Components/Budget";
import axiosInstance from "../../interceptor/interceptor";

// import Footer from '../../Components/Footer';
const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));
  

const ArbhiveBudget = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const budgetList = useSelector((state) => state.budgetReducer.archive_budgets);
    const currency = localStorage.getItem('currency');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    function moveBack(){
        navigate("/budgets");
      }

      useEffect(() => {
        fetchBudget();
      }, []);

      // Fetch Budgets.
      function fetchBudget() {
        try {
          const user_id = localStorage.getItem("user_text_obj_data1");
          dispatch(budgetActions.getBudgetList3({ user_id: user_id, status: 2 }));
        } catch (e) {
          alert(e);
        }
      }
    
    
    function renderSwitch(occurance, date_of_month, months) {
    if (occurance == 1) {
        return <Typography className="upperText">One Time Payment</Typography>;
    } else if (occurance == 2) {
        return (
        <Typography className="upperText">
            On {date_of_month}th of Every Month
        </Typography>
        );
    } else {
        return (
        <Typography className="upperText">
            On {date_of_month}th of {months}
        </Typography>
        );
    }
    }

    const budgetUnarchiveHandler = async (budget_id) => {
      try {
        let result = window.confirm("Want to Unarchive?");
        if (result) {
          setIsLoading(true);
          const res = await axiosInstance.post(
            `api?method=update_budget_status`,
            { budget_id: budget_id, status:1 }
          );
          setIsLoading(false);
          toast(res.data.message);
          setTimeout(()=>{
            dispatch(
              budgetActions.getBudgetList3({
                user_id: localStorage.getItem("user_text_obj_data1"),
                status: 2
              })
            );
          },0)
          
          
          
        }
      } catch (e) {
        toast.info(`Error: ${e}`, { type: "error" });
      }
    };
  
    
  return (
    <>
    {/* <ToastContainer /> */}
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
        <Box className="tabpanel-data">
      <Box sx={{ width: "100%" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <h3 style={{ textAlign: "center" }}>
            <Button className="top-nav-btn" variant="outlined">
              <KeyboardBackspaceRoundedIcon
                  onClick={moveBack}
                  style={{ cursor: "pointer", float: 'left',marginLeft: '10px !important' }}
                />
            </Button>
            
              Archive List</h3>
            <Demo style={{ minHeight: "500px" }}>
              {budgetList ? (
                <List>
                  {budgetList.length > 0 ? budgetList.map((data, index) => (
                    <div key={index}>
                      <ListItem
                        secondaryAction={
                          <>
                            <IconButton
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                budgetUnarchiveHandler(data.budget_id)
                              }
                            >
                              <Tooltip title="Click to Unarchive">
                              <UnarchiveOutlinedIcon />
                              </Tooltip>
                              
                            </IconButton>
                          </>
                        }
                      >
                        <div className="img-round">
                          <Box
                            component="img"
                            direction="column"
                            className="grid-item"
                            sx={{
                              maxHeight: { xs: 233, md: 167 },
                              maxWidth: { xs: 350, md: 250 },
                            }}
                            alt="Budget icon"
                            src={"./images/icons/" + data.budget_icon}
                          />
                        </div>
                        <div className="content_budget">
                          <h4>
                            {data.name}
                            <span className="budget-amount">
                              {currencyFormat(data.amount, currency)}
                            </span>
                          </h4>
                          {renderSwitch(
                            data.occurance,
                            data.date_of_month,
                            data.months
                          )}

                          <Typography className="botTexts">
                            {data.note}
                          </Typography>
                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  )): <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                  No Data Available
              </Box>}
                </List>
              ) : (
                <>
                  {/* <div id="overlay">
                    <div className="loader">
                      <CircularProgress />
                    </div>
                  </div> */}
                </>
              )}
            </Demo>
          </Grid>
        </Grid>
      </Box>
    </Box>
        </Grid>
      </Grid>

    </>
  );
};

export default ArbhiveBudget;
